<template>
    <header class="hero-head" id="w-header">
        <div class="columns is-vcentered hero-head__event">
            <div class="column is-narrow is-hidden-mobile">
                <figure class="hero-head__event__thumb image is-96x96 is-1by1">
                    <img class="is-rounded" :src="img" alt="">
                </figure>
            </div>
            <div class="column">
                <h1 class="hero-head__event__title title is-size-6-mobile is-size-5-tablet is-size-4-widescreen is-size-3-fullhd has-text-centered-mobile has-text-white-bis">
                    {{eventCard.name}}
                </h1>
                <div class="hero-head__event__info subtitle is-size-7-mobile is-size-6-tablet is-size-5-widescreen has-text-white-bis">
                    <div class="columns is-gapless-mobile is-variable is-1 is-mobile is-multiline">
                        <div class="column is-12-mobile is-narrow has-text-centered-mobile">
                            <time class="hero-head__event__date is-capitalized">
                                {{startDatetime}}
                            </time>
                        </div>
                        <template v-if="eventCard.hallName">
                            <div class="column is-narrow is-hidden-mobile">|</div>
                            <div class="column is-narrow-tablet has-text-centered-mobile">
                                <div class="hero-head__event__hall">
                                    {{eventCard.hallName}}
                                </div>
                            </div>
                        </template>
                        <template>
                            <div class="column is-narrow" v-if="eventCard.hallName">|</div>
                            <div class="column is-narrow-tablet has-text-centered-mobile">
                                <div class="hero-head__event__hall">
                                    {{sectionName}}
                                </div>
                            </div>
                        </template>
                        <!--                        <template v-if="eventCard.hallName">-->
                        <!--                            <div class="column is-narrow is-hidden-mobile">|</div>-->
                        <!--                            <div class="column is-narrow has-text-centered-mobile">-->
                        <!--                                <div class="hero-head__event__hall">-->
                        <!--                                    {{eventCard.hallName}}-->
                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                        </template>-->
                        <!--                        <template v-if="sectionName">-->
                        <!--                            <div class="column is-narrow is-hidden-mobile">|</div>-->
                        <!--                            <div class="column is-narrow has-text-centered-mobile">-->
                        <!--                                <div class="hero-head__event__hall">-->
                        <!--                                    {{sectionName}}-->
                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                        </template>-->
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import {mapState} from "vuex";
    import * as dayjs from 'dayjs'
    import 'dayjs/locale/ru'

    dayjs.locale('ru')

    export default {
        name: "WHeader",
        computed: {
            ...mapState({
                eventCard: state => state.eventCard,
                img: state => state.img,
                hallPlan: state => state.hallPlan,
            }),
            startDatetime() {
                return dayjs(this.eventCard.dateTime).format('DD MMMM YYYY, dd, HH:mm')
            },
            sectionName() {
                if (this.$route.name === 'Section' && this.hallPlan.length > 0) {
                    let sector = this.hallPlan.find(i => i.sectorId === parseInt(this.$route.params.section_id));
                    if (sector) {
                        return sector.name;
                    } else {
                        return '';
                    }
                } else {
                    return '';
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/variables";

    .hero {
        &-head {
            &__event {
                &__thumb {
                    img {
                        object-fit: cover;
                        object-position: center;
                    }
                }
                &__info {
                    .column {
                        @media(max-width: $desktop) {
                            padding-top: 0.25rem;
                            padding-bottom: 0.25rem;
                        }
                    }
                }
            }
        }
    }
</style>
